










import { Component, Vue } from 'vue-property-decorator';
// import { RadioGroup } from 'element-ui';
@Component({
  name: 'lb-radio-group'
  // components: {
  //   'el-radio-group': RadioGroup
  // }
})
export default class extends Vue {

}
